// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import SincronizarGoogle from "../../sesion/sincronizarGoogle";
import EliminarSincronizarGoogle from '../../sesion/eliminarSincronizacionGoogle';
import ZonaCargando from '../../alertas/zonaCargando';
import CambiarContrasena from '../../sesion/cambiarContra';
import VideoCuenta from '../../../componentesEspeciales/cuenta/videoCuenta';
import InfoPersonal from '../perfil/infoPersonal';
import SuscribirKlaviyo from '../../../componentesEspeciales/cuenta/suscribirKlaviyo';
import BotonVerificar from '../../../componentesEspeciales/cuenta/botonVerificar';
// estilos
import '../../../estilos/usuario.css';



function MiCuentaComprador() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
    // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);
    const inputAvatarRef           = useRef(null);
    const [ciudades, setCiudades] = useState([]);
    const [zonasPais, setZonasPais] = useState([]);
    const [impuestoPais, setImpuestoPais] = useState(0);
    const [infoPais, setInfoPais] = useState(null);
    const PAIS_POR_DEFECTO         = "Colombia";
    const [perfil, setPerfil] = useState({
        nombre: "",
        apellido: "",
        tipoIdentificacion: "Identificación nacional",
        identificacion: "",
        avatar: "",
        telefono: "",
        ciudad: "",
        pais: PAIS_POR_DEFECTO,
    });


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                const u = usuario;

                setPerfil({
                    nombre:   (u.nombre   && u.nombre   !== "NA") ? u.nombre   : "",
                    apellido: (u.apellido && u.apellido !== "NA") ? u.apellido : "",
                    tipoIdentificacion: (u.tipoIdentificacion && u.tipoIdentificacion !== "NA") ? u.tipoIdentificacion : "Identificación nacional",
                    identificacion: (u.identificacion && u.identificacion !== "NA") ? u.identificacion : "",
                    avatar: u.avatar,
                    telefono: u.telefono,
                    ciudad: u.ciudad,
                    pais: (u.pais && u.pais !== "NA") ? u.pais : PAIS_POR_DEFECTO,
                });
                
                // obtener info país (ciudades, zonas, impuesto)
                const paisElegido = (u.pais && u.pais !== "NA") ? u.pais : PAIS_POR_DEFECTO;
                const resPais = await axios.post("/obtener-info-pais-total", { params: { pais: paisElegido } });

                const contenido = resPais?.data?.contenidoPais || null;
                setInfoPais(contenido);
                setCiudades(Array.isArray(contenido?.ciudades) ? contenido.ciudades : []);
                setZonasPais(Array.isArray(contenido?.zonas) ? contenido.zonas : []);
                setImpuestoPais(typeof contenido?.impuesto === "number" ? contenido.impuesto : 0);
            }
            finally {
                setCargando(false);
            }
        })();
    }, [usuario, cargandoUsuario]);
    

    function cambiarCampo(campo, valor) { setPerfil(prev => ({ ...prev, [campo]: valor })); }

    function abrirSelectorAvatar() { if (inputAvatarRef.current) inputAvatarRef.current.click(); }

    function enlaceReferido() {
        const dominio = window.location.origin;
        return `${dominio}/${usuario?.username}/te-invito-a-zervicy`;
    }

    async function copiarEnlaceReferido() {
        try{
            const enlace = enlaceReferido();
            await navigator.clipboard.writeText(enlace);

            return Swal.fire({
                icon: 'success',
                title: 'Enlace copiado',
                text: 'Ya puedes compartir tu enlace de invitación.',
                timer: 1400,
                showConfirmButton: false,
                customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
            });
        }
        catch(err){
            console.log('Error copiando enlace de referido:', err);
            return Swal.fire({
                icon: 'error',
                title: 'No se pudo copiar',
                text: 'Copia el enlace manualmente e inténtalo de nuevo.',
                customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
            });
        }
    }

    

    async function guardarPerfil(tipoInfo) {

        let datosAenviar = {};

        if(tipoInfo === "Personal"){
            // Validaciones mínimas personal
            if (!perfil.nombre.trim() || !perfil.apellido.trim()) {
                return Swal.fire({ icon: 'error', title: 'Datos incompletos', text: 'Por favor completa nombre y apellido.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
            }

            if (!String(perfil.identificacion || "").trim()) {
                return Swal.fire({ icon: 'error', title: 'Datos incompletos', text: 'Por favor completa tu identificación.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
            }

            if (!String(perfil.telefono || "").trim()) {
                return Swal.fire({ icon: 'error', title: 'Datos incompletos', text: 'Por favor completa tu teléfono.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
            }

            datosAenviar = perfil;
        }

        // EJECUTAR FUNCION PARA ACTUALIZAR
        try {
            setCargando(true);
            const resCambio = await axios.post("/actualizar-perfil", {
                params: { idUsuario: usuario.idUsuario, tipoActualizacion: tipoInfo, datos: datosAenviar }
            });

            setCargando(false); // cancelo porque si no no se cancela
            await Swal.fire({ icon: 'success', title: 'Perfil actualizado', text: 'Tus datos se guardaron correctamente.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
            window.location.reload();
            return;
        }
        catch (err) {
            console.log('Error al guardar perfil:', err);
            return Swal.fire({ icon: 'error', title: 'No se pudo guardar', text: 'Ocurrió un error guardando tu perfil. Intenta de nuevo.', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
        }
        finally { setCargando(false); }

    }


    async function subirAvatar(e){
        try{
            setCargando(true);

            const files = e.target.files;
            if (!files || files.length === 0) return;
        
            const file = files[0];
            const formData = new FormData();
            formData.append("imagen", file);

            const response = await axios.post('/subir-avatar', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params: {  usuario: usuario.username, }
            });

            // actualizar página
            return window.location.reload();
        }
        catch(err){
            console.log("error al subir el avatar. ", err);
            return Swal.fire({ icon: 'error', title: 'Error al subir', text: 'Error al subir imagen. Intenta de nuevo', customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' } });
        }
        finally{
            setCargando(false);
        }
    }





    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Mi cuenta</h1>
 
                        <div className="d-flex align-items-center gap-2 flex-wrap ms-auto">
                            {/* klaviyo suscripción */}
                            {usuario && usuario.aceptaMarketing
                            ? <button className="btn btn-success" disabled> <i className="bi bi-check-circle-fill me-2"></i> Suscrito </button>
                            : <SuscribirKlaviyo usuario={usuario.username} setUsuario={setUsuario} />
                            }

                            <CambiarContrasena usuario={usuario.username} setUsuario={setUsuario} />

                            {usuario.googleId === "NA"
                                ? <SincronizarGoogle usuario={usuario.username} />
                                : <EliminarSincronizarGoogle usuario={usuario.username} />
                            }
                        </div>
                    </div>
                </div>
            </div>
            

            {/* Perfil */}
            <div className="container p-4 p-md-5 mb-4 bg-body-tertiary rounded-3">
                <div className="d-flex flex-column gap-4">
                    <div className="row g-4 align-items-center">
                    {/* Avatar */}
                    <div className="col-12 col-lg-6 d-flex justify-content-center">
                        <div className="w-100" style={{ maxWidth: "560px" }}>
                        <div className="card border-0 shadow-sm rounded-4 w-100">
                            <div className="card-body p-4">
                                <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start gap-4">
                                    <div className="text-center flex-shrink-0">
                                        <div className="position-relative overflow-hidden mx-auto" style={{ width: 150, height: 150, borderRadius: "50%" }}>
                                            <img
                                                className="fotoMiCuenta"
                                                src={perfil.avatar}
                                                alt="Avatar"
                                                style={{ width: 150, height: 150, objectFit: "cover", cursor: "pointer", borderRadius: "50%" }}
                                                onClick={abrirSelectorAvatar}
                                            />

                                            <button
                                                type="button"
                                                className="btn btn-dark btn-sm position-absolute start-0 bottom-0 w-100 rounded-0"
                                                style={{ opacity: 0.85 }}
                                                onClick={abrirSelectorAvatar}
                                            >
                                                Cambiar
                                            </button>

                                            <input
                                                ref={inputAvatarRef}
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                onChange={subirAvatar}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex-grow-1 w-100 text-center text-md-start">
                                        <p className='mb-1 fs-5'><strong>@{usuario.username}</strong></p>
                                        <p className='mb-3 text-muted'>{usuario.email}</p>

                                        <div className="rounded-4 p-3 text-start" style={{ background: "var(--color-bg-surface-alt)", border: "1px solid var(--color-border)" }}>
                                            <div className="d-flex align-items-start gap-2 mb-2">
                                                <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: "36px", height: "36px", background: "var(--naranja-fondo-melocoton)", color: "var(--naranja-cta)" }}>
                                                    <i className="bi bi-share-fill"></i>
                                                </div>
                                                <div>
                                                    <h6 className="fw-bold mb-1">Invita y comparte Zervicy</h6>
                                                    <p className="text-secondary small mb-0">Comparte tu enlace para que tus amigos se registren como referidos.</p>
                                                </div>
                                            </div>

                                            <div className="input-group mt-3">
                                                <input
                                                    type="text"
                                                    className="form-control bg-white"
                                                    value={enlaceReferido()}
                                                    readOnly
                                                    style={{ fontSize: "13px" }}
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-dark"
                                                    onClick={copiarEnlaceReferido}
                                                    title="Copiar enlace"
                                                >
                                                    <i className="bi bi-copy"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <BotonVerificar usuario={usuario} setUsuario={setUsuario} className="mt-3" />
                        </div>
                    </div>

                    {/* VIDEO EXPLICATIVO */}
                    <div className="col-12 col-lg-6">
                        <VideoCuenta />
                    </div>
                    </div>

                    {/* Formulario */}
                    <div className="w-100">


                        {/* INFO PERSONAL */}
                        <InfoPersonal
                            usuario={usuario}
                            perfil={perfil}
                            ciudades={ciudades}
                            cambiarCampo={cambiarCampo}
                            guardarPerfil={guardarPerfil}
                        />                    
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default MiCuentaComprador;